import React, { useState, useEffect } from 'react';
import { Card, Descriptions, Button, Space, Toast, Avatar, Table, Typography, Modal, Form, InputNumber, TabPane, Tabs } from '@douyinfe/semi-ui';
import { IconPlus } from '@douyinfe/semi-icons';
const { Text } = Typography;
import { useParams, useNavigate } from 'react-router-dom';
import request from '../../utils/request';
import styles from './index.module.scss';

const UserDetail = () => {
    const { userId } = useParams();
    const navigate = useNavigate();
    const [userDetail, setUserDetail] = useState(null);
    const [userAsset, setUserAsset] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showPointModal, setShowPointModal] = useState(false);
    const [showCashModal, setShowCashModal] = useState(false);
    const [adjustLoading, setAdjustLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(localStorage.getItem('userDetailActiveTab') || 'account');
    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '-';
        const date = new Date(parseInt(timestamp));
        return date.toLocaleString();
    };

    const formatBirthday = (birthday) => {
        if (!birthday) return '-';
        const str = birthday.toString();
        return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`;
    };

    const fetchUserDetail = async () => {
        try {
            const [userResponse, assetResponse] = await Promise.all([
                request.get('/go/sp/su/get_service_user/', {
                    params: { uid: userId }
                }),
                request.get('/go/sp/su/get_user_asset/', {
                    params: { uid: userId }
                })
            ]);

            if (userResponse.errno === 0 && userResponse.data) {
                setUserDetail(userResponse.data);
            } else {
                Toast.error(userResponse.errstr || '获取用户详情失败');
            }

            if (assetResponse.errno === 0 && assetResponse.data) {
                setUserAsset(assetResponse.data);
            } else {
                console.error('获取用户资产失败:', assetResponse.errstr);
            }
        } catch (error) {
            console.error('获取用户信息失败:', error);
            Toast.error('获取用户信息失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUserDetail();
    }, [userId]);

    if (loading) {
        return <div>加载中...</div>;
    }

    if (!userDetail) {
        return <div>未找到用户信息</div>;
    }

    return (
        <div className={styles.userDetailContainer}>
            <Card
                headerStyle={{ backgroundColor: 'var(--semi-color-bg-2)' }}
                className={styles.detailCard}
            >
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
                    <Avatar
                        size="large"
                        src={userDetail.avatar}
                        style={{ marginRight: '16px' }}
                    >
                        {userDetail.name?.[0] || userDetail.account?.[0] || '?'}
                    </Avatar>
                    <div>
                        <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '4px' }}>{userDetail.name || userDetail.account || '-'}</div>
                    </div>
                </div>
                <Tabs type="line" size="large" style={{ width: '100%' }} activeKey={activeTab} onChange={(key) => {
                    setActiveTab(key);
                    localStorage.setItem('userDetailActiveTab', key);
                }}>
                    <TabPane tab="账号信息" itemKey="account" style={{ flex: 1 }}>
                        <Descriptions
                            align="left"
                            size="small"
                            row
                            column={2}
                            data={[
                                { key: '账号', value: userDetail.account || '-' },
                                { key: '用户名', value: userDetail.name || '-' },
                                { key: '性别', value: userDetail.gender === 1 ? '男' : userDetail.gender === 2 ? '女' : '-' },
                                { key: '生日', value: userDetail.birthday ? formatBirthday(userDetail.birthday) : '-' },
                                { key: '微信号', value: userDetail.wechat || '-' },
                                { key: '推荐人ID', value: userDetail.from_su_uid || '-' },
                                { key: '来源渠道', value: userDetail.channel || '-' },
                                { key: '最后登录IP', value: userDetail.last_ip || '-' },
                                {
                                    key: '备注',
                                    value: userDetail.sp_remark ? (
                                        <div className="remark-content" style={{ whiteSpace: 'pre-wrap', maxWidth: '400px', color: 'red' }}>
                                            {userDetail.sp_remark}
                                        </div>
                                    ) : '-'
                                },
                                { key: '创建时间', value: formatTimestamp(userDetail.create_time) },
                                { key: '更新时间', value: formatTimestamp(userDetail.update_time) }
                            ]}
                        />
                    </TabPane>
                    <TabPane tab="资产信息" itemKey="asset" style={{ flex: 1 }}>
                        <Descriptions
                            align="left"
                            size="small"
                            row
                            column={2}
                            data={[
                                { key: '积分总额', value: userAsset ? `${userAsset.point_max || 0} 分` : '-' },
                                {
                                    key: '剩余积分',
                                    value: userAsset ? (
                                        <Text link onClick={() => navigate(`/points?uid=${userId}`)}>
                                            {`${userAsset.point_remain || 0} 分`}
                                        </Text>
                                    ) : '-'
                                },
                                { key: '已用积分', value: userAsset ? `${userAsset.point_used || 0} 分` : '-' },
                                {
                                    key: '账户余额',
                                    value: userAsset ? (
                                        <Text link onClick={() => navigate(`/cash?uid=${userId}`)}>
                                            {`¥${(parseInt(userAsset.cash_remain || 0) / 100).toFixed(2)}`}
                                        </Text>
                                    ) : '-'
                                },
                                { key: '已消费金额', value: userAsset ? `¥${(parseInt(userAsset.cash_used || 0) / 100).toFixed(2)}` : '-' }
                            ]}
                        />
                        <Space className={styles.actionButtons}>
                            <Button type="primary" size="large" icon={<IconPlus />} onClick={() => setShowPointModal(true)}>调整积分</Button>
                            <Button type="primary" size="large" icon={<IconPlus />} onClick={() => setShowCashModal(true)}>调整余额</Button>
                        </Space>
                    </TabPane>
                </Tabs>
                <Space className={styles.actionButtons} style={{ marginTop: '24px' }}>
                    <Button type="tertiary" size="large" onClick={() => navigate(-1)}>返回</Button>
                </Space>

                <Modal
                    title="调整积分"
                    visible={showPointModal}
                    onCancel={() => setShowPointModal(false)}
                    footer={null}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    bodyStyle={{ width: '100%', maxWidth: '520px' }}
                >
                    <Form
                        onSubmit={async (values) => {
                            setAdjustLoading(true);
                            try {
                                const response = await request.post('/go/sp/su/add_user_point/', {
                                    uid: userId,
                                    point: values.point,
                                    info: values.info
                                });
                                if (response.errno === 0) {
                                    Toast.success('调整成功');
                                    setShowPointModal(false);
                                    fetchUserDetail();
                                } else {
                                    Toast.error(response.errstr || '调整失败');
                                }
                            } catch (error) {
                                console.error('调整失败:', error);
                                Toast.error('调整失败');
                            } finally {
                                setAdjustLoading(false);
                            }
                        }}
                    >
                        <Form.InputNumber
                            field="point"
                            label="调整积分"
                            placeholder="请输入调整积分（负数表示减少）"
                            style={{ width: '100%' }}
                            rules={[{ required: true, message: '请输入调整积分' }]}
                        />
                        <Form.Input
                            field="info"
                            label="备注"
                            placeholder="请输入备注信息"
                            rules={[{ required: true, message: '请输入备注信息' }]}
                        />
                        <div style={{ marginTop: 24, textAlign: 'right', paddingBottom: 24 }}>
                            <Space>
                                <Button type="tertiary" onClick={() => setShowPointModal(false)}>取消</Button>
                                <Button type="primary" htmlType="submit" loading={adjustLoading}>确定</Button>
                            </Space>
                        </div>
                    </Form>
                </Modal>

                <Modal
                    title="调整余额"
                    visible={showCashModal}
                    onCancel={() => setShowCashModal(false)}
                    footer={null}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    bodyStyle={{ width: '100%', maxWidth: '520px' }}
                >
                    <Form
                        onSubmit={async (values) => {
                            setAdjustLoading(true);
                            try {
                                const response = await request.post('/go/sp/su/add_user_cash/', {
                                    uid: userId,
                                    cash: Math.round(values.cash * 100), // 转换为分
                                    info: values.info
                                });
                                if (response.errno === 0) {
                                    Toast.success('调整成功');
                                    setShowCashModal(false);
                                    fetchUserDetail();
                                } else {
                                    Toast.error(response.errstr || '调整失败');
                                }
                            } catch (error) {
                                console.error('调整失败:', error);
                                Toast.error('调整失败');
                            } finally {
                                setAdjustLoading(false);
                            }
                        }}
                    >
                        <Form.InputNumber
                            field="cash"
                            label="调整金额"
                            placeholder="请输入调整金额（负数表示减少）"
                            style={{ width: '100%' }}
                            rules={[{ required: true, message: '请输入调整金额' }]}
                            precision={2}
                        />
                        <Form.Input
                            field="info"
                            label="备注"
                            placeholder="请输入备注信息"
                            rules={[{ required: true, message: '请输入备注信息' }]}
                        />
                        <div style={{ marginTop: 24, textAlign: 'right', paddingBottom: 24 }}>
                            <Space>
                                <Button type="tertiary" onClick={() => setShowCashModal(false)}>取消</Button>
                                <Button type="primary" htmlType="submit" loading={adjustLoading}>确定</Button>
                            </Space>
                        </div>
                    </Form>
                </Modal>
            </Card>
        </div>
    );
};

export default UserDetail;